// extracted by mini-css-extract-plugin
export default {"wrapper":"_9dca1e2b","eligibleForTaxExemption":"_75c78cd2","isMobile":"_590ce162","checkbox":"_b313f52b","label":"_79e659de"};